{
  "schemaVersion": 1,
  "release": "0.1.0",
  "dataMode": "synthetic-educational",
  "nodes": [
    {
      "id": "BASE-A",
      "label": { "en": "Aqueous carrier-like", "zh": "水相载体类" },
      "category": { "en": "Base", "zh": "基底" },
      "description": { "en": "Synthetic placeholder for an aqueous carrier role.", "zh": "代表水相载体角色的合成占位节点。" },
      "roles": ["carrier", "aqueous-medium"],
      "intents": [{ "en": "aqueous delivery context", "zh": "水相承载环境" }],
      "evidenceIds": ["SYN-001"],
      "synthetic": true
    },
    {
      "id": "MOIST-B",
      "label": { "en": "Humectant-like", "zh": "保湿剂类" },
      "category": { "en": "Function", "zh": "功能" },
      "description": { "en": "Synthetic placeholder for a moisture-retention role.", "zh": "代表保湿功能角色的合成占位节点。" },
      "roles": ["humectancy"],
      "intents": [{ "en": "moisture-retention concept", "zh": "保湿功能概念" }],
      "evidenceIds": ["SYN-001"],
      "synthetic": true
    },
    {
      "id": "TEXT-C",
      "label": { "en": "Rheology modifier-like", "zh": "流变调节类" },
      "category": { "en": "Structure", "zh": "结构" },
      "description": { "en": "Synthetic placeholder for viscosity and structure control.", "zh": "代表黏度与结构控制的合成占位节点。" },
      "roles": ["rheology", "anionic-class-demo"],
      "intents": [{ "en": "structure-control concept", "zh": "结构控制概念" }],
      "evidenceIds": ["SYN-001"],
      "synthetic": true
    },
    {
      "id": "SURF-D",
      "label": { "en": "Cleansing surfactant-like", "zh": "清洁表活类" },
      "category": { "en": "Interface", "zh": "界面" },
      "description": { "en": "Synthetic placeholder for a cleansing-interface role.", "zh": "代表清洁界面角色的合成占位节点。" },
      "roles": ["cleansing", "anionic-class-demo"],
      "intents": [{ "en": "cleansing-interface concept", "zh": "清洁界面概念" }],
      "evidenceIds": ["SYN-001"],
      "synthetic": true
    },
    {
      "id": "COND-E",
      "label": { "en": "Conditioning agent-like", "zh": "调理剂类" },
      "category": { "en": "Function", "zh": "功能" },
      "description": { "en": "Synthetic placeholder for a cationic conditioning role.", "zh": "代表阳离子调理角色的合成占位节点。" },
      "roles": ["conditioning", "cationic-class-demo"],
      "intents": [{ "en": "conditioning concept", "zh": "调理功能概念" }],
      "evidenceIds": ["SYN-001"],
      "synthetic": true
    },
    {
      "id": "BUFFER-F",
      "label": { "en": "Buffer-like", "zh": "缓冲体系类" },
      "category": { "en": "Environment", "zh": "环境" },
      "description": { "en": "Synthetic placeholder for environmental pH planning.", "zh": "代表环境 pH 规划的合成占位节点。" },
      "roles": ["environment-control"],
      "intents": [{ "en": "pH-context planning", "zh": "pH 环境规划" }],
      "evidenceIds": ["SYN-001"],
      "synthetic": true
    },
    {
      "id": "BIND-G",
      "label": { "en": "Chelator-like", "zh": "螯合支持类" },
      "category": { "en": "Support", "zh": "支持" },
      "description": { "en": "Synthetic placeholder for metal-ion management questions.", "zh": "代表金属离子管理问题的合成占位节点。" },
      "roles": ["metal-ion-management"],
      "intents": [{ "en": "metal-ion-control concept", "zh": "金属离子控制概念" }],
      "evidenceIds": ["SYN-001"],
      "synthetic": true
    },
    {
      "id": "PRES-H",
      "label": { "en": "Preservation system placeholder", "zh": "防腐体系占位类" },
      "category": { "en": "Protection", "zh": "保护" },
      "description": { "en": "Synthetic planning node that never establishes preservation efficacy.", "zh": "仅用于规划、绝不证明防腐有效性的合成节点。" },
      "roles": ["preservation-planning"],
      "intents": [{ "en": "microbial-control planning", "zh": "微生物控制规划" }],
      "evidenceIds": ["SYN-001"],
      "synthetic": true
    },
    {
      "id": "OX-I",
      "label": { "en": "Oxidant-like", "zh": "氧化作用类" },
      "category": { "en": "Reactivity", "zh": "反应性" },
      "description": { "en": "Synthetic reactivity node used only to demonstrate a hard exclusion.", "zh": "仅用于演示硬性排斥逻辑的合成反应性节点。" },
      "roles": ["oxidation-context"],
      "intents": [{ "en": "oxidation-context concept", "zh": "氧化环境概念" }],
      "evidenceIds": ["SYN-001"],
      "synthetic": true
    },
    {
      "id": "RED-J",
      "label": { "en": "Reductant-like", "zh": "还原作用类" },
      "category": { "en": "Reactivity", "zh": "反应性" },
      "description": { "en": "Synthetic reactivity node used only to demonstrate a hard exclusion.", "zh": "仅用于演示硬性排斥逻辑的合成反应性节点。" },
      "roles": ["reduction-context"],
      "intents": [{ "en": "reduction-context concept", "zh": "还原环境概念" }],
      "evidenceIds": ["SYN-001"],
      "synthetic": true
    },
    {
      "id": "METAL-K",
      "label": { "en": "Metal-ion source-like", "zh": "金属离子来源类" },
      "category": { "en": "Environment", "zh": "环境" },
      "description": { "en": "Synthetic placeholder for a metal-ion context.", "zh": "代表金属离子环境的合成占位节点。" },
      "roles": ["metal-ion-context"],
      "intents": [{ "en": "metal-ion context", "zh": "金属离子环境" }],
      "evidenceIds": ["SYN-001"],
      "synthetic": true
    },
    {
      "id": "BIO-L",
      "label": { "en": "Bioactive-like", "zh": "生物活性物类" },
      "category": { "en": "Bio", "zh": "生物" },
      "description": { "en": "Synthetic placeholder for a condition-sensitive biological material.", "zh": "代表条件敏感型生物材料的合成占位节点。" },
      "roles": ["bioactive-context", "condition-sensitive"],
      "intents": [{ "en": "biological-function hypothesis", "zh": "生物功能假设" }],
      "evidenceIds": ["SYN-001"],
      "synthetic": true
    },
    {
      "id": "OIL-M",
      "label": { "en": "Oil-phase botanical-like", "zh": "油相植物物类" },
      "category": { "en": "Botanical", "zh": "植物" },
      "description": { "en": "Synthetic placeholder for an oil-phase botanical role.", "zh": "代表油相植物角色的合成占位节点。" },
      "roles": ["oil-phase", "botanical-context"],
      "intents": [{ "en": "oil-phase botanical concept", "zh": "油相植物功能概念" }],
      "evidenceIds": ["SYN-001"],
      "synthetic": true
    },
    {
      "id": "INTERFACE-N",
      "label": { "en": "Interface strategy-like", "zh": "界面策略类" },
      "category": { "en": "Interface", "zh": "界面" },
      "description": { "en": "Synthetic placeholder for an emulsion or dispersion strategy.", "zh": "代表乳化或分散策略的合成占位节点。" },
      "roles": ["interface-strategy", "dispersion-planning"],
      "intents": [{ "en": "phase-interface planning", "zh": "相界面规划" }],
      "evidenceIds": ["SYN-001"],
      "synthetic": true
    }
  ],
  "relations": [
    {
      "id": "REL-001", "left": "BASE-A", "right": "MOIST-B", "kind": "explore", "strength": "synthetic", "hardBlock": false,
      "reason": { "en": "The demo rule links an aqueous carrier role with a moisture-retention role.", "zh": "演示规则将水相载体角色与保湿角色相连。" },
      "action": { "en": "Explore the pair, then define real material identity and test conditions.", "zh": "可以探索该组合，但必须补充真实材料身份并设计实验条件。" },
      "conditions": [], "evidenceIds": ["SYN-001"], "ruleVersion": "1.0.0", "lastReviewed": "2026-07-12"
    },
    {
      "id": "REL-002", "left": "BASE-A", "right": "TEXT-C", "kind": "explore", "strength": "synthetic", "hardBlock": false,
      "reason": { "en": "The demo rule connects aqueous context with structure-control planning.", "zh": "演示规则将水相环境与结构控制规划相连。" },
      "action": { "en": "Explore only after defining material grade, ionic environment, and process conditions.", "zh": "只有在明确材料等级、离子环境与工艺条件后才能继续探索。" },
      "conditions": [], "evidenceIds": ["SYN-001"], "ruleVersion": "1.0.0", "lastReviewed": "2026-07-12"
    },
    {
      "id": "REL-003", "left": "BUFFER-F", "right": "PRES-H", "kind": "conditional", "strength": "synthetic", "hardBlock": false,
      "reason": { "en": "Preservation planning depends on declared environmental conditions; a buffer role alone proves nothing.", "zh": "防腐规划依赖明确的环境条件；仅有缓冲角色不能证明任何效果。" },
      "action": { "en": "Supply pH, material identity, use context, and an experimental verification plan.", "zh": "补充 pH、材料身份、使用场景和实验验证计划。" },
      "conditions": [{ "en": "pH and use context required", "zh": "需要 pH 与使用场景" }], "evidenceIds": ["SYN-001"], "ruleVersion": "1.0.0", "lastReviewed": "2026-07-12"
    },
    {
      "id": "REL-004", "left": "SURF-D", "right": "COND-E", "kind": "conflict", "strength": "synthetic", "hardBlock": false,
      "reason": { "en": "The synthetic charge-class rule marks this pair as a potential interaction for review.", "zh": "合成电荷类别规则将该组合标记为需要审查的潜在相互作用。" },
      "action": { "en": "Do not combine from this demo. Replace placeholders with sourced material-specific evidence.", "zh": "不要依据此演示进行组合；应使用带来源的具体材料证据替换占位规则。" },
      "conditions": [{ "en": "material identity and charge behavior required", "zh": "需要材料身份与电荷行为信息" }], "evidenceIds": ["SYN-001"], "ruleVersion": "1.0.0", "lastReviewed": "2026-07-12"
    },
    {
      "id": "REL-005", "left": "OX-I", "right": "RED-J", "kind": "conflict", "strength": "synthetic", "hardBlock": true,
      "reason": { "en": "This intentionally synthetic rule demonstrates a hard-exclusion path for opposing reactivity classes.", "zh": "此纯合成规则用于演示相反反应性类别的硬性排斥路径。" },
      "action": { "en": "The demo blocks selection. A real assertion would require condition-specific experimental evidence.", "zh": "演示系统会阻止选择；真实断言必须有特定条件下的实验证据。" },
      "conditions": [{ "en": "demo-only hard block", "zh": "仅演示用硬性阻断" }], "evidenceIds": ["SYN-001"], "ruleVersion": "1.0.0", "lastReviewed": "2026-07-12"
    },
    {
      "id": "REL-006", "left": "BIND-G", "right": "METAL-K", "kind": "conditional", "strength": "synthetic", "hardBlock": false,
      "reason": { "en": "A metal-binding role can change the availability of a declared metal-ion context.", "zh": "金属结合角色可能改变已声明金属离子环境的可用状态。" },
      "action": { "en": "Define identity, purpose, environment, and analytical checks before proceeding.", "zh": "继续前应明确身份、用途、环境和分析检查。" },
      "conditions": [{ "en": "identity and analytical endpoint required", "zh": "需要身份信息与分析终点" }], "evidenceIds": ["SYN-001"], "ruleVersion": "1.0.0", "lastReviewed": "2026-07-12"
    },
    {
      "id": "REL-007", "left": "OX-I", "right": "BIO-L", "kind": "conflict", "strength": "synthetic", "hardBlock": false,
      "reason": { "en": "The demo conservatively separates an oxidation context from a condition-sensitive biological placeholder.", "zh": "演示系统保守地将氧化环境与条件敏感型生物占位节点分离。" },
      "action": { "en": "Require identity-specific stability evidence before considering this relationship.", "zh": "考虑该关系前必须提供针对具体身份的稳定性证据。" },
      "conditions": [{ "en": "identity-specific stability evidence required", "zh": "需要针对具体身份的稳定性证据" }], "evidenceIds": ["SYN-001"], "ruleVersion": "1.0.0", "lastReviewed": "2026-07-12"
    },
    {
      "id": "REL-008", "left": "BASE-A", "right": "BIO-L", "kind": "conditional", "strength": "synthetic", "hardBlock": false,
      "reason": { "en": "A biological-material role requires environment, activity, and stability context.", "zh": "生物材料角色需要环境、活性与稳定性背景。" },
      "action": { "en": "Declare identity and acceptance criteria before treating this as an explorable pairing.", "zh": "在将其视为可探索搭配前，应声明身份和验收标准。" },
      "conditions": [{ "en": "identity, activity, and stability criteria required", "zh": "需要身份、活性和稳定性标准" }], "evidenceIds": ["SYN-001"], "ruleVersion": "1.0.0", "lastReviewed": "2026-07-12"
    },
    {
      "id": "REL-009", "left": "OIL-M", "right": "INTERFACE-N", "kind": "explore", "strength": "synthetic", "hardBlock": false,
      "reason": { "en": "The demo links an oil-phase role with an explicit interface-strategy role.", "zh": "演示规则将油相角色与明确的界面策略角色相连。" },
      "action": { "en": "Explore only after defining real materials and physical-stability tests.", "zh": "只有在明确真实材料并设计物理稳定性试验后才能探索。" },
      "conditions": [], "evidenceIds": ["SYN-001"], "ruleVersion": "1.0.0", "lastReviewed": "2026-07-12"
    },
    {
      "id": "REL-010", "left": "BASE-A", "right": "OIL-M", "kind": "conditional", "strength": "synthetic", "hardBlock": false,
      "reason": { "en": "Separate phase roles need an explicit interface or dispersion strategy.", "zh": "不同相态角色需要明确的界面或分散策略。" },
      "action": { "en": "Add a sourced interface strategy and define stability observations.", "zh": "补充有来源的界面策略，并定义稳定性观察项目。" },
      "conditions": [{ "en": "interface strategy required", "zh": "需要界面策略" }], "evidenceIds": ["SYN-001"], "ruleVersion": "1.0.0", "lastReviewed": "2026-07-12"
    },
    {
      "id": "REL-011", "left": "BASE-A", "right": "INTERFACE-N", "kind": "explore", "strength": "synthetic", "hardBlock": false,
      "reason": { "en": "The demo links an aqueous context with interface planning.", "zh": "演示规则将水相环境与界面规划相连。" },
      "action": { "en": "Define the actual dispersed phase and verification plan.", "zh": "明确实际分散相并制定验证计划。" },
      "conditions": [], "evidenceIds": ["SYN-001"], "ruleVersion": "1.0.0", "lastReviewed": "2026-07-12"
    },
    {
      "id": "REL-012", "left": "TEXT-C", "right": "METAL-K", "kind": "conditional", "strength": "synthetic", "hardBlock": false,
      "reason": { "en": "The synthetic rule flags ionic environment as a rheology-review condition.", "zh": "合成规则将离子环境标记为需要审查的流变条件。" },
      "action": { "en": "Define identities and measure the structure response under intended conditions.", "zh": "明确材料身份，并在目标条件下测量结构响应。" },
      "conditions": [{ "en": "ionic environment and structure test required", "zh": "需要离子环境信息与结构测试" }], "evidenceIds": ["SYN-001"], "ruleVersion": "1.0.0", "lastReviewed": "2026-07-12"
    },
    {
      "id": "REL-013", "left": "PRES-H", "right": "BIO-L", "kind": "conditional", "strength": "synthetic", "hardBlock": false,
      "reason": { "en": "A biological-material placeholder and preservation placeholder require identity-specific evidence.", "zh": "生物材料占位节点与防腐占位节点需要针对具体身份的证据。" },
      "action": { "en": "Define material identity, intended use, and a suitable verification protocol.", "zh": "明确材料身份、预期用途与合适的验证方案。" },
      "conditions": [{ "en": "identity and verification protocol required", "zh": "需要身份信息与验证方案" }], "evidenceIds": ["SYN-001"], "ruleVersion": "1.0.0", "lastReviewed": "2026-07-12"
    }
  ],
  "effects": [
    {
      "id": "EFF-001", "requires": ["BASE-A", "MOIST-B"],
      "title": { "en": "Moisture-retention concept", "zh": "保湿功能概念" },
      "explanation": { "en": "The selected roles express an aqueous moisture-retention hypothesis; performance remains untested.", "zh": "所选角色表达了水相保湿假设，但实际表现仍未验证。" },
      "evidenceIds": ["SYN-001"], "strength": "synthetic"
    },
    {
      "id": "EFF-002", "requires": ["BASE-A", "TEXT-C"],
      "title": { "en": "Aqueous-structure concept", "zh": "水相结构概念" },
      "explanation": { "en": "The selected roles express an aqueous structure-control hypothesis; stability remains untested.", "zh": "所选角色表达了水相结构控制假设，但稳定性仍未验证。" },
      "evidenceIds": ["SYN-001"], "strength": "synthetic"
    },
    {
      "id": "EFF-003", "requires": ["OIL-M", "INTERFACE-N"],
      "title": { "en": "Interface-assisted dispersion concept", "zh": "界面辅助分散概念" },
      "explanation": { "en": "The selected roles express a phase-interface planning hypothesis; no dispersion outcome is established.", "zh": "所选角色表达了相界面规划假设，但尚未证明分散结果。" },
      "evidenceIds": ["SYN-001"], "strength": "synthetic"
    },
    {
      "id": "EFF-004", "requires": ["BASE-A", "BIO-L"],
      "title": { "en": "Biological-material environment question", "zh": "生物材料环境问题" },
      "explanation": { "en": "The selection raises an environment-and-activity verification question; it does not establish a biological effect.", "zh": "该选择提出环境与活性验证问题，并不证明任何生物效果。" },
      "evidenceIds": ["SYN-001"], "strength": "synthetic"
    }
  ],
  "evidence": [
    {
      "id": "SYN-001",
      "title": "BioFormulation Constellation synthetic demonstration rules",
      "organization": "Professeur Haipeng",
      "uri": "https://github.com/ProfesseurHaipeng/bioformulation-constellation/blob/main/docs/KNOWLEDGE_MODEL.md",
      "license": "MIT",
      "evidenceCode": "SYNTHETIC-DEMO",
      "note": {
        "en": "Synthetic educational assertions created to test software behavior; not experimental evidence.",
        "zh": "用于测试软件行为的合成教育断言，不属于实验证据。"
      }
    }
  ]
}
